import { render } from "./VideoCollectionsNetflix.vue?vue&type=template&id=496f1639&scoped=true"
import script from "./VideoCollectionsNetflix.vue?vue&type=script&lang=js"
export * from "./VideoCollectionsNetflix.vue?vue&type=script&lang=js"

import "./VideoCollectionsNetflix.vue?vue&type=style&index=0&id=496f1639&scoped=true&lang=css"
import "./VideoCollectionsNetflix.vue?vue&type=style&index=1&id=496f1639&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496f1639"]])

export default __exports__